export default __webpack_public_path__ + "media/application/assets/images/signing-instructions/SCWitness-bd96238b1b134495e545561ca910abe1.PNG";